import { CurrencyAmount as VivaCurrencyAmount } from '@/core/components'

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VivaCurrencyAmount,{ref:"amountInput",staticClass:"loyalty-amount-input",attrs:{"id":"amount","aria-label":_vm.$t('accessibility:loyaltyAmountCurrency', {
        'currencySymbol': _vm.currency.symbol
    }),"prefix":_vm.currency.symbol,"label":_vm.$t('common:enterAmount'),"locale":_vm.currency.format,"format-pattern":'0,0.00',"rules":{
        required: true,
        more_than:[_vm.inputValue, _vm.minRedemptionAmount, _vm.currency],
        less_than:[_vm.inputValue, _vm.maxRedemptionAmount, _vm.currency]
    }},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }